diy.angular.registerFactory('diyfmsourcestorage', [
    '$injector',
    '$q',
    '$resource',
    '$http',
    'diyfmconfig',
    'diyl10n',
    'diyappevents',
    'diyfmfolders',
    'diyfmconststorage',
    'diywebsiteid',
    'diyfmmessages',
    'diyfmconstbigstockpurchased',
function(
    $injector,
    $q,
    $resource,
    $http,
    diyfmconfig,
    diyl10n,
    diyappevents,
    diyfmfolders,
    diyfmconststorage,
    diywebsiteid,
    diyfmmessages,
    diyfmconstbigstockpurchased
) {
    var
        source = {},
        itemsProviderUrl = '/rest/websites/' + diywebsiteid + '/storage-files/'
    ;

    var getName = function() {
        return 'storage';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectionstorage');
    };

    var rangeParams;

    var itemsProvider = $resource(itemsProviderUrl + ':id', {
            id: '@id'
         }, {
            'create':   {method:'POST'},
            'update': {method: 'PUT'},
            'query': {
                method: 'GET',
                isArray: true,
                headers: {
                    'X-Diy-Range': function(config) {
                        if (rangeParams) {
                            return 'items=' + Math.max(0, rangeParams.offset)
                                + '-' + Math.max(0, rangeParams.offset + rangeParams.limit - 1);
                        }
                        return null;
                    }
                }
            }
        }
    );

    itemsProvider.batchDelete = function(ids) {
        return $http({
            method: 'DELETE',
            url: itemsProviderUrl,
            data: ids
        });
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        var defer = $q.defer(), dataParams = angular.extend({}, params);

        if (dataParams !== undefined && !!dataParams.search) {
            dataParams.publicName = dataParams.search;
            dataParams.search = undefined;
        }
        // XXX temporary set local variable rangeParams
        // so that it could be used in above transformRequest function
        rangeParams = {
            offset: offset,
            limit: limit
        };
        itemsProvider.query(dataParams, function(data, headersGetter){
            var
                totalCount,
                contentRange = headersGetter()['x-diy-content-range']
            ;
            if (contentRange) {
                // Content-Range header have a format like "range start-end/total" (i.e. "items 0-99/200")
                totalCount = parseInt(contentRange.split('/')[1], 10);
            }
            defer.resolve({items: data, totalCount: totalCount});
        }, function(httpResponse) {
            diyfmmessages.handleGenericError();
            defer.reject();
        });
        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    angular.module(diyfmconfig.getAppName()).compileProvider.directive('diyfmtoolbardeleteselected', [
       'diyl10n',
       'diyfmsectionsdata',
       'diyfmselectiondata',
       'diyfmmessages',
       function(
            diyl10n,
            diyfmsectionsdata,
            diyfmselectiondata,
            diyfmmessages
       ){
        return {
            template: '<button class="ui-button-borderless fm-toolbar-delete" \
                title="' + diyl10n('filemanager.deleteSelectedButton.title') + '"></button>',
            restrict: 'A',
            scope: true,
            link: function(scope, elem, attr) {
                var
                    $elem = jQuery(elem),
                    deleteBtn = $elem.find('.fm-toolbar-delete')
                ;

                var deleteSelected = function() {
                    diyfmmessages.showMessageItemsThumbs({
                        items: diyfmselectiondata.getSelectedItems(),
                        title: diyl10n('filemanager.toolbar.deleteconfirmation.message').format(diyfmselectiondata.getSelectedItems().length),
                        ok: diyl10n('filemanager.sections.menu.delete'),
                        cancel: diyl10n('cancel')
                    }).then(function() {
                        var itemsToDelete = diyfmselectiondata.getSelectedItems();
                        var itemsToDeleteCount = itemsToDelete.length;
                        diyfmsectionsdata.getCurrentSubsection().deleteItems(itemsToDelete);
                        scope.$emit('deleteFilesClicked', {
                            itemsCount: itemsToDeleteCount
                        });
                    });
                };


                deleteBtn
                    .button({
                        icons: {primary: 'ui-icon-trash'},
                        text: false,
                        // initially we don't have any item selected, so button should be disabled
                        disabled: true
                    })
                    .click(function(){
                        deleteSelected();
                        scope.$apply();
                    });

                scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(){
                    var selCount = diyfmselectiondata.getSelectedItems().length;
                    deleteBtn.button('option', 'disabled', selCount === 0);
                });
            }
        }
    }]);

    var toolbarItems = [
        ' ', // spacer
        'search'
    ];

    var managementToolbarItems = [
        'selectall',
        function() {
            return '<div diyfmtoolbardeleteselected></div>';
        },
        '-', // separator
        ' ', // spacer
        'search'
    ];

    var bigstockToolbarItems = [];

    var getToolbarItems = function(subsection) {
        if (subsection.getId() === diyfmconstbigstockpurchased) {
            return bigstockToolbarItems;
        } else {
            if (diyfmconfig.isInManagementMode()) {
                return managementToolbarItems;
            } else {
                return toolbarItems;
            }
        }
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        getToolbarItems: getToolbarItems
    });
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sources/diyfmsourcestorage.js
 ** module id = 946
 ** module chunks = 0
 **/